export { default as SmileIcon } from './SmileIcon';
